import Vue from 'vue'
import CONFIG from './../../config.js'
let actions = {

  transactions(context, params) {
    context.commit('addLog', { request: 'LoadTxns' })
    return new Promise((resolve, reject) => {
      Vue.axios.post(CONFIG.getEndpoint('transactions'), params.query, {
        headers: {
          Authorization: 'Bearer ' + (params.sessionId || localStorage.getItem("Authorization")),
        }
      }).then((response) => {
        context.commit('transactions', response.data)
        context.commit('removeLog', { request: 'LoadTxns' })
        resolve()
      }).catch((err) => {
        // context.commit('hideLoader')
        // context.commit('removeLog', { request:'Home' })
        if (err.response.status == 401) {
          localStorage.removeItem("Authorization")
          localStorage.removeItem("User")
          //Unset session id in store
          context.commit('user', undefined)
        }
        reject(err.response)
        context.commit('removeLog', { request: 'LoadTxns' })
      })
    })
  },
  updateTransaction(context, params) {

    return new Promise((resolve, reject) => {

      Vue.axios.post(CONFIG.getEndpoint('updateTransaction'), params.query, {
        headers: {
          Authorization: 'Bearer ' + (params.sessionId || localStorage.getItem("Authorization")),
        }
      }).then((response) => {

        // context.commit('updateTransaction', response.data)
        resolve(response)
      }).catch((err) => {
        // context.commit('hideLoader')
        // context.commit('removeLog', { request:'Home' })
        if (err.response.status == 401) {
          localStorage.removeItem("Authorization")
          localStorage.removeItem("User")
          //Unset session id in store
          context.commit('user', undefined)
        }
        reject(err.response)
      })
    })
  },
  updateTransactionWithAmount(context, params) {
    return new Promise((resolve, reject) => {
      Vue.axios.post(CONFIG.getEndpoint('updateTransactionWithAmount') + params.txn_id + '/returned', params.query, {
        headers: {
          Authorization: 'Bearer ' + (params.sessionId || localStorage.getItem("Authorization")),
        }
      }).then((response) => {
        // context.commit('updateTransactionWithAmount', response.data)
        resolve(response)
      }).catch((err) => {
        // context.commit('hideLoader')
        // context.commit('removeLog', { request:'Home' })
        if (err.response.status == 401) {
          localStorage.removeItem("Authorization")
          localStorage.removeItem("User")
          //Unset session id in store
          context.commit('user', undefined)
        }
        // context.commit('hideLoader')
        // context.commit('removeLog', { request:'Home' })
        reject(err.response)
      })
    })
  },
  JSONtoCSV(context, params) {
    const items = params;
    const replacer = (key, value) => {
      switch (value) {
        case 'confirmed' || 'confirmed_update' || 'shipped':
          return 'confirmed';
        case 'returned' || 'return_initiated':
          return 'returned';
        case 'partially_settled' || 'delivered':
          return 'delivered';
        case !value:
          return '';
        default:
          return value;
      }
    };
    // const header = Object.keys( items[0] );
    const header = ["id", "marketplaceOrderId", "txnDateStr", "txnAmount", "status"]
    let csv = items.map(row =>
      header
        .map(fieldName => JSON.stringify(row[fieldName], replacer))
        .join(",")
    );
    csv.unshift(header.join(","));
    csv = csv.join("\r\n");
    context.commit('csv', csv)
    context.commit('removeLog', { request: 'csv' })
  },
  allTransactions(context, params) {
    context.commit('addLog', { request: 'LoadTxns' })
    return new Promise((resolve, reject) => {
      Vue.axios.post(CONFIG.getEndpoint('transactions'), params.query, {
        headers: {
          Authorization: 'Bearer ' + (params.sessionId || localStorage.getItem("Authorization")),
        }
      }).then((response) => {
        context.commit('allTransactions', response.data)
        context.commit('removeLog', { request: 'LoadTxns' })
        resolve()
      }).catch((err) => {
        // context.commit('hideLoader')
        // context.commit('removeLog', { request:'Home' })
        if (err.response.status == 401) {
          localStorage.removeItem("Authorization")
          localStorage.removeItem("User")
          //Unset session id in store
          context.commit('user', undefined)
        }
        reject(err.response)
        context.commit('removeLog', { request: 'LoadTxns' })
      })
    })
  },
  deliveryUpdate(context, params) {
    context.commit('addLog', { request: 'DeliveryUpdate' })
    return new Promise((resolve, reject) => {
      Vue.axios.post(CONFIG.getEndpoint('deliveryUpdate', params.txn_id), params.query, {
        headers: {
          Authorization: 'Bearer ' + (params.sessionId || localStorage.getItem("Authorization")),
        }
      }).then((response) => {
        resolve(response)
        context.commit('removeLog', { request: 'DeliveryUpdate' })
        resolve()
      }).catch((err) => {
        if (err.status == 401) {
          localStorage.removeItem("Authorization")
          localStorage.removeItem("User")
          context.commit('user', undefined)
        }
        reject(err)
        context.commit('removeLog', { request: 'DeliveryUpdate' })
      })
    })
  }
}
export default actions



// WEBPACK FOOTER //
// ./src/store/transactions/actions.js